import React from 'react';
import { Modal } from '@mantine/core';
import { Button } from '../Button';
import classes from './confirm-modal.module.scss';

export type ConfirmModalProps = {
  opened: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  dataTestId: string;
};

// Shared critical-action confirmation (DESIGN_RULES §4): verb on the right, ביטול on the left.
export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  opened,
  title,
  message,
  confirmLabel,
  onConfirm,
  onCancel,
  isSubmitting = false,
  dataTestId,
}) => (
  <Modal
    opened={opened}
    onClose={() => {
      if (!isSubmitting) {
        onCancel();
      }
    }}
    title={title}
    centered
    radius="md"
    zIndex={302}
    closeOnClickOutside={!isSubmitting}
    closeOnEscape={!isSubmitting}
    closeButtonProps={{ 'data-testid': `${dataTestId}-close` } as Record<string, string>}
  >
    <div className={classes.body} data-testid={`${dataTestId}-modal`}>
      <p className={classes.text}>{message}</p>
      <div className={classes.actions}>
        <Button variant="confirm" fullWidth loading={isSubmitting} onClick={onConfirm} dataTestId={`${dataTestId}-confirm`}>
          {confirmLabel}
        </Button>
        <Button variant="cancel" fullWidth disabled={isSubmitting} onClick={onCancel} dataTestId={`${dataTestId}-cancel`}>
          ביטול
        </Button>
      </div>
    </div>
  </Modal>
);
